export default __webpack_public_path__ + "static/media/commentActive.2c4e3b13.svg";